import React, {useEffect, useState} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import auth from "./auth/auth";
import {Loading} from "./components/Loading";
import {AuthCode} from "./auth/AuthCode";
import moment from "moment";
import "./assets/scss/Dashboard.scss";
import "./assets/scss/Static.scss";
import {AlertContext, LanguageContext} from "./store/use_context";
import Cookies from 'js-cookie';
import {setLocalization} from "./localization/MainLocalization";
import {lang_ar} from "./localization/Ar";
import {lang_en} from "./localization/En";
import {jssPreset, StylesProvider, ThemeProvider} from "@material-ui/core/styles";
import {ThemeOne} from "./layout/Themes";
import rtl from "jss-rtl";
import {Redirect} from "react-router";
import {create} from "jss";
import {NotFoundOne} from "./pages/notfound/NotFoundOne";
import {Layout} from "./layout/Layout";


const jss = create({
  plugins: [...jssPreset().plugins, rtl()],
});


export const not_validate_value = [undefined, null, ""];
export var dir = "LTR";


export var redirect = "/dashboard";

export function setRedirect(value) {
  redirect = `/${value}`;
}

export function timeTo12Hour(time) {
  return moment("1995-06-09 " + time).format("hh:mm A")
}

export function timeTo24Hour(time) {
  return moment("1995-06-09 " + time).format("hh:mm")
}


const AppContent = () => {
  const [alert_msg, setAlert] = useState("");

  return(
      <Switch>
        <AlertContext.Provider value={{alert_msg, setAlert}}>
          <Route path="*" component={Layout}/>
        </AlertContext.Provider>
      </Switch>
  );
}


const App = () => {
  const [is_loading, setIsLoading] = useState(true)
  const [language, setLanguage] = useState(Cookies.get('language') || "en")

  const setLanguageSetting = async () => {
    if (language === 'en') {
      dir = 'ltr';
      await setLocalization(lang_en);
    } else {
      dir = 'rtl'
      await setLocalization(lang_ar)
    }
    document.body.dir = dir;
  }

  const changeLanguage = async () => {
    if (language === 'en') {
      await setLanguage('ar')
      await Cookies.set('language', 'ar');
    } else {
      await setLanguage('en')
      await Cookies.set('language', 'en');
    }
  }

  useEffect(() => {
    const checkAuth = async () => {
      await setLanguageSetting()
      let isAuth = await auth.checkAuthenticate();
      if (isAuth.status) {
        setIsLoading(false)
      }
    }

    checkAuth();
  }, [])


  useEffect(() => {
    const action = async () => {
      if (is_loading) {
        await setLanguageSetting();
      } else {
        await setIsLoading(true);
        await setLanguageSetting();
        await setIsLoading(false);
      }
    }

    action();
  }, [language]);


  return (
      <>
        {is_loading? (
            <Loading/>
        ) : (
            <LanguageContext.Provider value={{changeLanguage}}>
              <BrowserRouter>
                <Switch>
                  <Route path="/notfound" component={NotFoundOne}/>
                  <Route path='/auth' component={AuthCode}/>
                  <Route exact path="/" render={() => <Redirect to="/dashboard"/>}/>
                  <ThemeProvider theme={ThemeOne(dir)}>
                    {(language === 'en') ? <AppContent/> :
                        (
                            <StylesProvider jss={jss}>
                              <AppContent/>
                            </StylesProvider>
                        )
                    }
                  </ThemeProvider>
                </Switch>
              </BrowserRouter>
            </LanguageContext.Provider>
        )}

      </>
  );
}

export default App;
